import { stockRequestBody } from "./stockContext";


import { apiFetch } from "./apiFetch";

async function parseStockNewsResponse(resp, fallbackMessage) {
  const data = await resp.json().catch(() => ({}));
  if (!resp.ok) {
    throw new Error(data.message || data.error || fallbackMessage);
  }
  return data;
}

export async function fetchStockNewsQuestions(serverUrl, stockSession) {
  const data = await parseStockNewsResponse(
    await apiFetch(`${serverUrl}/listStockNewsQuestions`, {
      method: "POST",
      body: JSON.stringify(stockRequestBody(stockSession)),
    }),
    "Failed to load news questions"
  );
  return Array.isArray(data.questions) ? data.questions : [];
}

export async function createStockNewsQuestion(serverUrl, stockSession, questionText, { labels } = {}) {
  const body = { question_text: questionText };
  if (labels !== undefined) body.labels = labels;
  const data = await parseStockNewsResponse(
    await apiFetch(`${serverUrl}/createStockNewsQuestion`, {
      method: "POST",
      body: JSON.stringify(stockRequestBody(stockSession, body)),
    }),
    "Failed to create question"
  );
  return data.question;
}

export async function updateStockNewsQuestion(serverUrl, stockSession, { questionId, questionText, status, labels }) {
  const payload = { questionId };
  if (questionText != null) payload.question_text = questionText;
  if (status != null) payload.status = status;
  if (labels !== undefined) payload.labels = labels;
  const data = await parseStockNewsResponse(
    await apiFetch(`${serverUrl}/updateStockNewsQuestion`, {
      method: "POST",
      body: JSON.stringify(stockRequestBody(stockSession, payload)),
    }),
    "Failed to update question"
  );
  return data.question;
}

export async function renameStockNewsQuestionLabel(serverUrl, stockSession, { oldLabel, newLabel }) {
  const data = await parseStockNewsResponse(
    await apiFetch(`${serverUrl}/renameStockNewsQuestionLabel`, {
      method: "POST",
      body: JSON.stringify(stockRequestBody(stockSession, { oldLabel, newLabel })),
    }),
    "Failed to rename label"
  );
  return typeof data.modifiedCount === "number" ? data.modifiedCount : 0;
}

export async function removeStockNewsQuestionLabel(serverUrl, stockSession, label) {
  const data = await parseStockNewsResponse(
    await apiFetch(`${serverUrl}/removeStockNewsQuestionLabel`, {
      method: "POST",
      body: JSON.stringify(stockRequestBody(stockSession, { label })),
    }),
    "Failed to remove label"
  );
  return typeof data.modifiedCount === "number" ? data.modifiedCount : 0;
}

export async function reopenAllStockNewsQuestions(serverUrl, stockSession) {
  const data = await parseStockNewsResponse(
    await apiFetch(`${serverUrl}/reopenAllStockNewsQuestions`, {
      method: "POST",
      body: JSON.stringify(stockRequestBody(stockSession)),
    }),
    "Failed to reopen questions"
  );
  return typeof data.modifiedCount === "number" ? data.modifiedCount : 0;
}

export async function duplicateStockNewsQuestion(serverUrl, stockSession, questionId) {
  const data = await parseStockNewsResponse(
    await apiFetch(`${serverUrl}/duplicateStockNewsQuestion`, {
      method: "POST",
      body: JSON.stringify(stockRequestBody(stockSession, { questionId })),
    }),
    "Failed to duplicate question"
  );
  return data.question;
}

export async function deleteStockNewsQuestion(serverUrl, stockSession, questionId) {
  await parseStockNewsResponse(
    await apiFetch(`${serverUrl}/deleteStockNewsQuestion`, {
      method: "POST",
      body: JSON.stringify(stockRequestBody(stockSession, { questionId })),
    }),
    "Failed to delete question"
  );
}
